import { render, staticRenderFns } from "./BaseDataTable.vue?vue&type=template&id=4c57387c"
import script from "./BaseDataTable.vue?vue&type=script&lang=js"
export * from "./BaseDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports